import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { RBACProvider } from './contexts/RBACContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <RBACProvider>
            <ToastProvider>
              <SnackbarProvider>
                <BrowserRouter>
                  <AppRoutes />
                </BrowserRouter>
              </SnackbarProvider>
            </ToastProvider>
          </RBACProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
